import type { FAQPolicyValues } from "../faq-data.ts";
import type { FaqBuilder } from "./index.ts";

const buildFaqsIt: FaqBuilder = (p: FAQPolicyValues, fmt) => {
  const secondaryLine =
    p.secondaryCountryName && p.secondaryFreeAbove
      ? ` Verso il Belgio la spedizione è gratuita a partire da €${fmt.eur(p.secondaryFreeAbove)}.`
      : "";
  return [
    {
      category: "Prodotti e allergie",
      items: [
        {
          q: "Ho un'allergia, i vostri prodotti sono adatti a me?",
          a: "Nella quasi totalità dei casi i nostri prodotti sono adatti. Mandaci un'email con la tua allergia specifica e ti consigliamo personalmente quali prodotti sono sicuri per te. Puoi anche ordinare prima un campione per testare il prodotto su una piccola zona di pelle.",
        },
        {
          q: "Che cosa significa ipoallergenico?",
          a: "Ipoallergenico significa che la probabilità di una reazione allergica è estremamente ridotta. Tutti i prodotti di Unity Cosmetics sono ipoallergenici. Scegliamo deliberatamente ingredienti che comportano il minor rischio possibile di irritazione.",
        },
        {
          q: "Come posso testare se un prodotto è adatto a me?",
          a: "Ti consigliamo di provare prima il prodotto su una piccola zona all'interno del gomito. Se hai una sensibilità o una reazione allergica, questa si manifesta generalmente entro 24 ore sotto forma di prurito, leggero arrossamento e talvolta piccoli rigonfiamenti. Per la maggior parte dei prodotti sono disponibili campioni.",
        },
        {
          q: "I vostri prodotti sono vegani?",
          a: "Gran parte del nostro assortimento è vegano. Nella pagina del prodotto, tra le classificazioni, è indicato se il prodotto è vegano. Tutti i prodotti sono cruelty-free.",
        },
        {
          q: "I vostri prodotti contengono glutine?",
          a: "Tutti i nostri prodotti sono senza glutine. Anche questo è indicato tra le classificazioni sulla pagina del prodotto.",
        },
      ],
    },
    {
      category: "Ordini e pagamenti",
      items: [
        {
          q: "Quali metodi di pagamento accettate?",
          a: "Accettiamo iDEAL, Visa, Mastercard, PayPal, Klarna (paga dopo), Bancontact e bonifico SEPA.",
        },
        {
          q: "Quando ricevo il mio ordine?",
          a: `Gli ordini vengono consegnati entro ${fmt.deliveryWindow} tramite ${p.carrier} con Track & Trace. Riceverai un'email di conferma con il codice di tracciamento non appena il tuo pacco sarà spedito.`,
        },
        {
          q: "La spedizione è gratuita?",
          a: `Sì, per ordini a partire da €${fmt.eur(p.primaryFreeAbove)} la spedizione nei Paesi Bassi è gratuita.${secondaryLine}`,
        },
        {
          q: "Posso ordinare anche dei campioni?",
          a: "Sì, per la maggior parte dei prodotti sono disponibili campioni. Così puoi testare il prodotto sulla tua pelle prima di acquistare la versione completa.",
        },
      ],
    },
    {
      category: "Resi",
      items: [
        {
          q: "Posso restituire un prodotto?",
          a: `Hai ${p.returnWindowDays} giorni di tempo per ripensarci dopo aver ricevuto il tuo ordine. I prodotti devono essere restituiti non aperti e nella confezione originale. Le spese di reso sono a tuo carico (circa €${fmt.eur(p.returnCost)}).`,
        },
        {
          q: "Cosa devo fare se ho una reazione allergica?",
          a: "Contattaci subito. Anche se con i nostri prodotti la probabilità è estremamente ridotta, prendiamo sul serio ogni reazione. Ti aiutiamo a trovare una soluzione adeguata.",
        },
      ],
    },
  ];
};

export default buildFaqsIt;
